import { render, staticRenderFns } from "./approvalModal.vue?vue&type=template&id=38d6f8f8&scoped=true&"
import script from "./approvalModal.vue?vue&type=script&lang=js&"
export * from "./approvalModal.vue?vue&type=script&lang=js&"
import style0 from "./approvalModal.vue?vue&type=style&index=0&id=38d6f8f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d6f8f8",
  null
  
)

export default component.exports